import { Component, inject, OnDestroy, OnInit, ViewChild, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SuperButton, TranslateService } from '@devinforius/super-compos-17';
import { getButtonsTitle, getColumnsModelesPoints } from './config';
import { Title } from '@angular/platform-browser';
import { UserInfo } from 'src/app/shared/models/user-info';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import { IGlobalElements } from 'src/app/shared/models/common/IGlobalElements';
import { Global_Class } from 'src/app/shared/models/global';
import { Point } from 'src/app/shared/models/point';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { InfosFormComponent } from './infos-form.component';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { ModelePoint } from 'src/app/shared/models/modele-point';
import { Model_Point_Biblio } from 'src/app/shared/models/model_point_from_bibliotheque';
import * as _ from 'underscore';
import { IDelibeMeService } from 'src/app/core/services/idelibe/me.service';
import { MeRightPoint } from 'src/app/shared/models/point/me-right-point.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentEditor } from 'src/app/shared/models/content-editor';
import { ContentComponent } from '../content/content.component';
import * as async from 'async';
import { HttpErrorResponse } from '@angular/common/http';
import { IFromDuplicationPointDetails } from 'src/app/shared/models/point/IFromDuplicationPointDetails';
import { IButton } from '@devinforius/i-essentials';

@Component({
  selector: 'app-infos',
  templateUrl: './infos.component.html',
  styleUrls: ['./infos.component.scss'],
})
export class InfosComponent implements OnInit, OnDestroy {
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly titleService: Title = inject(Title);
  private readonly apiAdmin: iAdminService = inject(iAdminService);
  private readonly api: ApiService = inject(ApiService);
  private readonly dataS: DataService = inject(DataService);
  private readonly toastr: ToastrService = inject(ToastrService);
  private readonly confirmationService: ConfirmationService = inject(ConfirmationService);
  private readonly iDelibeGlobalService: IDelibeGlobalService = inject(IDelibeGlobalService);
  private readonly iDelibeMeService: IDelibeMeService = inject(IDelibeMeService);
  private readonly spinner: NgxSpinnerService = inject(NgxSpinnerService);

  @ViewChild(InfosFormComponent) infosFormComponent: InfosFormComponent;
  @ViewChild(ContentComponent) contentComponent: ContentComponent;

  private lockExpiration: boolean = false;
  private timerInterval: string | number;

  public pointId: number;
  public pointsRights: MeRightPoint;
  public appliedModelePoint = null;
  public allServices = [];
  public allClasseurs = [];
  public allChemises = [];
  public listOfCodesActives = [];
  public userInfos: UserInfo;
  public statut: 'create' | 'update' | 'createFromIcourrier' | 'duplicate';
  public buttons: IButton[];
  public columnsModelesPoints;
  public isLocked: boolean = false;
  public writeLock: { currentUser: boolean } = {
    currentUser: true,
  };
  public itemFiles = [];
  public filteredModelesPoints = [];
  public actualPoint: Point = null;
  public globalElements;
  public point: Point;
  public itemsTabs: Array<any> = [
    { header: this.translate.translate('infosAndLinks') },
    { header: this.translate.translate('content'), disabled: true },
    { header: this.translate.translate('joinedFiles'), disabled: true },
  ];
  public menuModelesPoint: Array<any> = [
    {
      label: this.translate.translate('btn.use'),
      command: () => {
        this.applyModelePoint(this.selectedRowModelePoint);
      },
    },
  ];
  public selectedRowModelePoint = null;
  public activeTab: number = 0;
  public showAllAccordion: boolean = false;
  public activeState: boolean[] = [false, false, false];
  public allModelesPoints: ModelePoint[] = [];
  public openModelesPointsModal: boolean = false;
  public contenuStaticRTFFilesPresents;
  public icourrierID: number;

  public ngOnInit(): void {
    this.fetchInfoRoute();
    this.buttons = getButtonsTitle(this, this.translate);
    this.columnsModelesPoints = getColumnsModelesPoints();

    this.listenToFormChanges();
  }

  public ngOnDestroy(): void {
    if (this.statut === 'createFromIcourrier') {
      localStorage.removeItem('iDelibe_duplicateFileFromiCourrier');
      localStorage.removeItem('iDelibe_icourrier_id_send');
    }
  }

  private fetchInfoRoute(): void {
    const url = this.activatedRoute.snapshot.routeConfig.path;
    const segments = url.split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1];

    if (lastSegment === 'create') {
      this.titleService.setTitle(this.translate.translate('title.createPoint'));
      this.statut = 'create';
      this.safeSubscribeToFetchInfos();
    } else if (lastSegment === ':id') {
      if (segments[1] === 'duplicate') {
        this.titleService.setTitle(this.translate.translate('title.duplicatePoint'));
        this.itemsTabs[1].disabled = false;
        this.itemsTabs[2].disabled = false;
        this.statut = 'duplicate';
        this.pointId = +this.activatedRoute.snapshot.params['id'];
        this.safeSubscribeToFetchInfos();
      } else {
        this.titleService.setTitle(this.translate.translate('title.updatePoint'));
        this.itemsTabs[1].disabled = false;
        this.itemsTabs[2].disabled = false;
        this.statut = 'update';
        this.pointId = +this.activatedRoute.snapshot.params['id'];
        this.safeSubscribeToFetchInfos();
      }
    } else {
      this.titleService.setTitle(this.translate.translate('title.createPoint'));
      this.statut = 'createFromIcourrier';
      this.safeSubscribeToFetchInfos();
    }
  }

  private safeSubscribeToFetchInfos(): void {
    const fetchResult = this.fetchInfos();
    if (fetchResult && typeof fetchResult.subscribe === 'function') {
      fetchResult.subscribe();
    } else {
      console.warn('fetchInfos() did not return a valid Observable');
    }
  }

  private fetchUserInfos(): Observable<UserInfo> {
    return this.apiAdmin.getUserInfo();
  }

  private fetchInfos(): Observable<any> {
    return this.fetchUserInfos().pipe(
      tap((userInfos) => (this.userInfos = userInfos)),
      switchMap(() => this.getGlobalElements()),
      tap((element) => (this.globalElements = new Global_Class(element))),
      switchMap(() => {
        if (this.statut === 'update' || this.statut === 'duplicate') {
          return this.getPointId();
        } else {
          return of(null);
        }
      }),
      tap((point) => {
        if (point) {
          this.actualPoint = new Point(point, this.globalElements);
          this.checkIfThePointIsLocked();
        }
      })
    );
  }

  public goBack(): void {
    window.history.back();
  }

  private checkIfThePointIsLocked(): void {
    const currentUser: boolean = this.userInfos.id === this.actualPoint.writeLock.writeLockUserId;
    this.writeLock = {
      currentUser: currentUser,
    };
    if (!this.actualPoint.writeLock.locked) {
      this.lockPoint();
    } else {
      this.isLocked = true;
    }
  }

  applyModelePoint(event): void {
    this.appliedModelePoint = event;
    this.infosFormComponent.setInfoForm(event);
    this.openModelesPointsModal = false;
  }

  /**
   * A method to lock a point. It logs the point ID and update status, then locks the point using the API.
   * If the update is successful, it handles the response. If there's an error, it checks for specific error statuses and messages, then performs the corresponding actions.
   */
  lockPoint(): void {
    if (this.statut === 'update' && this.pointId) {
      this.api.lockPoint(this.pointId).subscribe(
        (res: Point['writeLock']) => {
          const currentUser: boolean = this.userInfos.id === res.writeLockUserId;
          this.writeLock.currentUser = currentUser;
          this.isLocked = res.locked;
          this.scheduleLockExpirationProcess(res);
          this.toastr.info(this.translate.translate('info.pointLocked'));
        },
        (error) => {
          if (error.status === 403 && error.error.message === 'PointWriteLockedByOtherUser') {
            this.isLocked = true;
          } else {
            // pour le moment si il y a une ereur autre que celle du dessus, il est aussi ejecté de la page.
            this.isLocked = true;
          }
        }
      );
    }
  }

  /**
   * Looks at the expiration date and calls handelLockExpiration 1 minutes before the end of the expiration
   */
  private scheduleLockExpirationProcess(infos: Point['writeLock']): void {
    if (infos && infos.writeLockExpirationDateTime) {
      const expirationDateTime = infos.writeLockExpirationDateTime;
      const expirationMoment = moment.utc(expirationDateTime); // Calculate expiration based on UTC
      const oneMinuteBeforeExpiration = expirationMoment.subtract(1, 'minutes').toDate();
      const currentTime = new Date();
      const timeToWait = oneMinuteBeforeExpiration.getTime() - currentTime.getTime();

      if (timeToWait > 0) {
        setTimeout(() => {
          this.handleLockExpiration();
        }, timeToWait);
      }
    }
  }

  /**
   * A method that handles the lock expiration process.
   */
  private handleLockExpiration(): void {
    this.lockExpiration = true;
    this.timer();
  }

  /**
   * A function that starts a timer and updates the timer display every second.
   */
  private timer(): void {
    let seconds: number = 60;
    let textSec: string | number = '0';
    let statSec: number = 60;

    const timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.timerInterval = textSec;

      if (seconds == 0) {
        this.goBack();
        clearInterval(timerInterval);
      }
    }, 1000);
  }

  private getGlobalElements(): Observable<IGlobalElements> {
    return this.dataS.getGlobalElements;
  }

  private getPointId(): Observable<any> {
    return this.api.getPointByID(this.pointId);
  }

  //* reloads the datas that displays if a RTF has data sin it
  reloadRTFPresence(goToNextStep: boolean = false): void {
    this.api.getPointContenuStaticRTFFilesPresents(this.pointId).subscribe((res) => {
      this.contenuStaticRTFFilesPresents = res;
      if (goToNextStep) {
        this.nextStep();
      }
    });
  }

  //* next step on tabs
  nextStep(): void {
    if (this.activeTab < 3) {
      this.activeTab++;
      const data: object = { index: this.activeTab };
      this.changeTab(data);
    }
  }

  //* when the user changes tabs/ Dynamic tab change
  changeTab(event): void {
    // Si on est dans les fichiers et qu'on veut revenir sur les infos & liens,
    //on demande si il est sur pcq il va perdre les changements qu'il a fait dans les éditeurs
    if (this.activeTab === 1 && event.index === 0) {
      this.confirmationService.confirm({
        message: 'Etes-vous sûr de vouloir quitter cet écran ?  Vos données seront perdues.',
        key: 'create',
        accept: () => {
          this.showAllAccordion = false;
          const arrayRTF = ['Motivation', 'Decision', 'Observations', 'ComplementDeDeliberation', 'NotesDeSynthese'];
          arrayRTF.map((_, index) => {
            this.activeState[index] = false;
          });
          this.activeTab = 0;
          this.infosFormComponent.ngOnInit();
        },
        reject: () => {
          setTimeout(() => {
            this.activeTab = 1;
          }, 1000);
        },
      });
    } else if (this.activeTab === 1 && event.index === 2) {
      this.confirmationService.confirm({
        message: 'Etes-vous sûr de vouloir quitter cet écran ?  Vos données seront perdues.',
        key: 'create',
        accept: () => {
          this.showAllAccordion = false;
          const arrayRTF = ['Motivation', 'Decision', 'Observations', 'ComplementDeDeliberation', 'NotesDeSynthese'];
          arrayRTF.map((_, index) => {
            this.activeState[index] = false;
          });
          this.activeTab = 2;
          this.getPointFiles();
          this.buttons = [
            {
              text: this.translate.translate('btn.leave'),
              styleClass: 'blue',
              icon: 'fas fa-check-square',
              iconPosition: 'left',
              id: 'idLeave',
              click: () => {
                if (this.statut === 'update') {
                  this.realeseWriteLock();
                } else {
                  this.leave();
                }
              },
            },
          ];
        },
        reject: () => {
          setTimeout(() => {
            this.activeTab = 1;
          }, 1000);
        },
      });
    } else {
      if (this.pointId) {
        this.iDelibeMeService.getRightsPoint(this.pointId).subscribe((rights: MeRightPoint) => {
          this.pointsRights = rights;
        });
      }
      this.activeTab = event.index;
      if ((event.index === 1 || event.index === 2) && !this.pointId && this.statut !== 'createFromIcourrier') {
        this.activeTab = 0;
        this.toastr.error("Veuillez d'abord sauvegarder votre point avant d'ajouter ces données");
      } else {
        if (event.index === 1 || (this.pointId && event.index === 0)) {
          event.index === 1 ? this.reloadRTFPresence() : null;
          this.buttons = [
            {
              text: this.translate.translate('btn.saveAndLeave'),
              styleClass: 'blue',
              icon: 'fas fa-check-square',
              iconPosition: 'left',
              id: 'idSaveAndLeave',
              click: () => {
                this.validateAndSave(true);
              },
            },
            {
              text: this.translate.translate('btn.saveAndNextStep'),
              styleClass: 'green',
              id: 'idValidateAndNextStep',
              icon: 'fas fa-arrow-circle-right',
              iconPosition: 'left',
              disabled: !this.infosFormComponent.infosForm.valid,
              click: () => {
                this.validateAndSave();
              },
            },
          ];
        }
        if (event.index === 2 && this.pointId) {
          this.getPointFiles();
          this.buttons = [
            {
              text: this.translate.translate('btn.leave'),
              styleClass: 'blue',
              icon: 'fas fa-check-square',
              iconPosition: 'left',
              id: 'idLeave',
              click: () => {
                this.realeseWriteLock();
              },
            },
          ];
        }
      }
    }
  }

  //* Simple update of point
  updatePoint(): void {
    if (this.updatingPoint()) return;

    this.updatingPoint.set(true);
    this.deactivateButtons();

    if (this.infosFormComponent.infosForm.valid) {
      this.infosFormComponent.infosForm.patchValue({
        dossierClassementId: this.infosFormComponent.infosForm.value.sleeve
          ? this.infosFormComponent.infosForm.value.sleeve
          : this.infosFormComponent.infosForm.value.folder
            ? this.infosFormComponent.infosForm.value.folder
            : null,
        unlockPoint: true,
        agentTraitantIdiAdmin: this.infosFormComponent.infosForm.value.agentTraitantIdiAdmin?.value,
      });
      //To include every control value
      this.infosFormComponent?.infosForm.enable();
      this.infosFormComponent?.infosForm.updateValueAndValidity();
      this.api
        .putUpdatePoint(this.pointId, new Point(this.infosFormComponent.infosForm.getRawValue()))
        .pipe(
          finalize(() => {
            this.updatingPoint.set(false);
            this.activateButtons();
          })
        )
        .subscribe((res: Point) => {
          this.toastr.success(this.translate.translate('success.updatedPoint'));
          setTimeout(() => {
            this.router.navigateByUrl('/private/points/detail/' + res.id);
          }, 500);
        });
    } else {
      this.invalidFormToastr();
    }
  }

  private deactivateButtons(): void {
    this.buttons = this.buttons.map((button: IButton) => ({
      ...button,
      disabled: true,
      loading: true,
    }));
  }

  private activateButtons(): void {
    this.buttons = this.buttons.map((button: IButton) => ({
      ...button,
      disabled: false,
      loading: false,
    }));
  }

  updateButtons(event): void {
    if (this.statut !== 'update') {
      if (event.serviceId) {
        const childbtn = this.buttons.find((x) => x.id === 'idUsePointModel');
        if (childbtn) {
          childbtn.disabled = false;
        }
      } else {
        const childbtn = this.buttons.find((x) => x.id === 'idUsePointModel');
        if (childbtn) {
          childbtn.disabled = true;
        }
      }
    }
  }

  private handleResponseError(err: HttpErrorResponse): void {
    if (err?.error?.errors?.length) {
      err.error.errors.forEach((err) => {
        this.toastr.error(err.message);
      });
    }
  }

  private duplicatePoint(shouldLeave: boolean = false): void {
    if (this.duplicatingPoint()) return;

    this.duplicatingPoint.set(true);
    this.deactivateButtons();

    const currentDuplicatedPoint = this.dataS.duplicatedPointManagement.value;

    const { recipients, infos, files, listOfFiles } = currentDuplicatedPoint;

    const newPoint = new Point(this.infosFormComponent.infosForm.getRawValue());

    newPoint.modelePointId = this.appliedModelePoint ? this.appliedModelePoint.id : null;

    if (!this.appliedModelePoint) {
      delete newPoint.modelePointId;
    }

    newPoint.FichiersIds = listOfFiles ? (listOfFiles.length && files ? listOfFiles : []) : [];

    this.api
      .postDuplicatePoint(this.pointId, newPoint, recipients ?? false, infos ?? false)
      .pipe(
        finalize(() => {
          this.spinner.hide();
          this.duplicatingPoint.set(false);
          this.activateButtons();
        })
      )
      .subscribe({
        next: (point) => {
          this.toastr.success(this.translate.translate('success.duplicatePoint'));
          shouldLeave ? this.leave(point.id) : this.nextStep();
        },
        error: this.handleResponseError,
      });
  }

  private updateAPoint(shouldLeave: boolean = false): void {
    this.api
      .putUpdatePoint(this.pointId, new Point(this.infosFormComponent.infosForm.getRawValue()))
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: () => {
          this.toastr.success(this.translate.translate('success.updatePoint'));
          shouldLeave ? this.leave() : this.nextStep();
        },
        error: this.handleResponseError,
      });
  }

  private createAPoint(): void {
    this.creatingPoint.set(true);
    this.deactivateButtons();

    let createdPoint: any;

    const newPoint = new Point(this.infosFormComponent.infosForm.getRawValue());
    newPoint.modelePointId = this.appliedModelePoint ? this.appliedModelePoint.id : null;

    if (!this.appliedModelePoint) {
      delete newPoint.modelePointId;
    }

    this.api
      .postCreatePoint(newPoint as any)
      .pipe(
        switchMap((res) => {
          this.toastr.success(this.translate.translate('success.createdPoint'));
          createdPoint = res;

          return this.iDelibeMeService.getRightsPoint(createdPoint.id);
        })
      )
      .pipe(
        finalize(() => {
          this.spinner.hide();
          this.activateButtons();
          this.creatingPoint.set(false);
        })
      )
      .subscribe({
        next: (rights: MeRightPoint) => {
          if (!rights.edit) {
            setTimeout(() => {
              this.spinner.hide();
              this.router.navigateByUrl('/private/points/detail/' + createdPoint.id);
            }, 500);
          } else {
            this.point = createdPoint;
            this.pointId = createdPoint.id;
            this.itemsTabs[1].disabled = false;
            this.itemsTabs[2].disabled = false;
            if (this.appliedModelePoint) {
              this.reloadRTFPresence(true);
            } else {
              this.spinner.hide();
              this.nextStep();
            }
          }
        },
        error: this.handleResponseError,
      });
  }

  private readonly creatingPoint = signal<boolean>(false);
  private readonly updatingPoint = signal<boolean>(false);
  private readonly duplicatingPoint = signal<boolean>(false);

  validateAndSave(leave: boolean = false, statut?: string): void {
    if (this.creatingPoint()) return;

    if (this.activeTab === 0) {
      if (this.infosFormComponent.infosForm.valid) {
        this.infosFormComponent.infosForm.patchValue({
          dossierClassementId: this.infosFormComponent.infosForm.value.sleeve
            ? this.infosFormComponent.infosForm.value.sleeve
            : this.infosFormComponent.infosForm.value.folder
              ? this.infosFormComponent.infosForm.value.folder
              : null,
          serviceId: this.infosFormComponent.infosForm.value.serviceId.id
            ? this.infosFormComponent.infosForm.value.serviceId.id
            : this.infosFormComponent.infosForm.value.serviceId
              ? this.infosFormComponent.infosForm.value.serviceId
              : null,
        });

        if (leave) {
          this.infosFormComponent.infosForm.patchValue({ unlockPoint: true });
        }

        this.spinner.show();
        if (this.pointId) {
          statut === 'duplicate' ? this.duplicatePoint(leave) : this.updateAPoint(leave);
        } else {
          this.createAPoint();
        }
      } else {
        this.invalidFormToastr();
      }
    } else if (this.activeTab === 1) {
      this.saveAllRTFPromise();
      if (leave) {
        if (this.statut === 'update') {
          this.realeseWriteLock();
        } else {
          this.leave();
        }
      } else {
        this.nextStep();
      }
    }
  }

  importFileFromCourrierId(): void {
    this.api.getIcourrierFiles(this.infosFormComponent.infosForm.value.courrierId).subscribe(
      (res: any) => {
        this.toastr.success(this.translate.translate('success.file.imported'));
        this.itemFiles = res;
      },
      (err) => {
        if (err?.error?.message && err?.error?.message === 'Mail not found') {
          this.toastr.error("Ce courrier n'a pas pu être retrouvé, veuillez vérifier son identifiant");
        } else if (err.status === 401) {
          this.toastr.error("Vous n'êtes pas autorisé à importer ce courrier");
        } else {
          this.toastr.error('Une erreur est survenue');
        }
      }
    );
  }

  getPointFiles(): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.pointId) {
        resolve(false);
        return;
      }
      this.api.getPointFiles(this.pointId).subscribe((pointFiles: any) => {
        this.itemFiles = pointFiles;
        resolve(true);
      });
      this.spinner.hide();
    });
  }

  //* Saving all RTF
  saveAllRTFPromise(): Promise<boolean> {
    return new Promise((resolve) => {
      const data = [];
      const names = [];

      // On parcourt simplement le tableau contentEditors
      for (const item of this.contentComponent.contentEditors) {
        const value = Object.values(item)[0];
        if (value !== null) {
          data.push(value);
          names.push(Object.keys(item));
        }
      }

      this.api.putMultiplePointRTFDatasStatic(this.pointId, data, names).subscribe(
        () => {
          this.toastr.success(this.translate.translate('message.success.dataSaved'));
          resolve(true);
        },
        () => {
          this.toastr.error('Une erreur est survenue lors de la sauvegarde');
          resolve(false);
        }
      );
    });
  }

  invalidFormToastr(): void {
    this.markInvalidControlsAsTouched();

    if (!this.infosFormComponent.infosForm.controls['seanceId'].valid) {
      this.toastr.error(this.translate.translate('error.emptySeance'));
    }
    if (!this.infosFormComponent.infosForm.controls['statutId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyStatus'));
    }
    if (!this.infosFormComponent.infosForm.controls['objetSynthese'].valid) {
      this.toastr.error(this.translate.translate('error.emptyTitle'));
    }
    if (!this.infosFormComponent.infosForm.controls['typeSeanceId'].valid) {
      this.toastr.error(this.translate.translate('error.emptySeanceType'));
    }
    if (!this.infosFormComponent.infosForm.controls['serviceId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyDepartment'));
    }
    if (!this.infosFormComponent.infosForm.controls['echevinatId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyAldermansAdminDepartment'));
    }
    if (!this.infosFormComponent.infosForm.controls['classementId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyClassement'));
    }
    if (!this.infosFormComponent.infosForm.controls['matiereId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyMatter'));
    }
    if (!this.infosFormComponent.infosForm.controls['origine'].valid) {
      this.toastr.error(this.translate.translate('error.emptyOrigin'));
    }
    if (!this.infosFormComponent.infosForm.controls['typeDecisionId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyTypeDecision'));
    }
    if (!this.infosFormComponent.infosForm.controls['typeId'].valid) {
      this.toastr.error(this.translate.translate('error.emptyTypePoint'));
    }
    if (!this.infosFormComponent.infosForm.controls['agentTraitantIdiAdmin'].valid) {
      this.toastr.error("L'agent sélectionné n'est pas valide");
    }
    if (
      this.infosFormComponent.infosForm.controls['urgenceNiveauId'].errors?.required === true &&
      !this.infosFormComponent.infosForm.controls['urgenceNiveauId'].valid
    ) {
      this.toastr.error(this.translate.translate('error.emptyEmergency'));
    }
  }

  getModelesPoints(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.iDelibeGlobalService
        .getGlobalModelesPointsByIdsService([this.infosFormComponent.infosForm.value.serviceId])
        .subscribe((res: ModelePoint[]) => {
          this.allModelesPoints = res;
          this.filterModelesPoints();
          resolve(true);
        });
    });
  }

  filterModelesPoints(): void {
    let modelesFiltered = this.allModelesPoints.filter(
      (x: ModelePoint) => x.serviceId === null || x.serviceId === this.infosFormComponent.infosForm.value.serviceId
    );
    if (this.infosFormComponent.infosForm.value.typeSeanceId) {
      modelesFiltered = modelesFiltered.filter(
        (x: ModelePoint) =>
          x.typeSeanceId === null || x.typeSeanceId === this.infosFormComponent.infosForm.value.typeSeanceId
      );
    }
    this.filteredModelesPoints = modelesFiltered.map((x: ModelePoint) => {
      return new Model_Point_Biblio(
        x,
        this.globalElements.types_seances_LV,
        this.globalElements.types_points_LV,
        this.allServices,
        this.globalElements.matieres_LV,
        this.globalElements.decision_type_LV,
        this.listOfCodesActives,
        this.allClasseurs,
        this.allChemises
      );
    });
    this.filteredModelesPoints = _.sortBy(this.filteredModelesPoints, 'serviceLabel');
    //ici on va juste placer les modèles sans service au dessus de tout
    const modelesNoService = this.filteredModelesPoints.filter((x) => !x.serviceId);
    const otherModeles = this.filteredModelesPoints.filter((x) => x.serviceId);
    this.filteredModelesPoints = modelesNoService.concat(otherModeles);
    this.openModelesPointsModal = true;
  }

  setRowModelePoint(event): void {
    this.selectedRowModelePoint = event;
  }

  realeseWriteLock(goBack: boolean = true): void {
    this.api.ReleaseWriteLock(this.pointId).subscribe(
      (res: Point['writeLock']) => {
        if (res) {
          this.toastr.info(this.translate.translate('info.pointUnlocked'));
          this.lockExpiration = false;
          if (goBack) this.leave();
        }
      },
      () => {
        this.toastr.error(this.translate.translate('errorOccurred'));
      }
    );
  }

  public leave(pointId?: number): void {
    this.router.navigateByUrl('/private/points/detail/' + (pointId ?? this.pointId));
  }
  getTitleText(): string {
    switch (this.statut) {
      case 'update':
        return 'btn.updatePoint';
      case 'duplicate':
        return 'btn.duplicatePoint';
      case 'create':
      case 'createFromIcourrier':
      default:
        return 'btn.createPoint';
    }
  }
  private listenToFormChanges(): void {
    setTimeout(() => {
      if (this.infosFormComponent?.infosForm) {
        this.infosFormComponent.infosForm.valueChanges.subscribe(() => {
          this.markInvalidControlsAsTouched();
          if (this.infosFormComponent.infosForm.valid) {
            this.buttons = getButtonsTitle(this, this.translate);
          }
        });
      }
    }, 100);
  }
  private markInvalidControlsAsTouched(): void {
    if (!this.infosFormComponent?.infosForm) {
      return;
    }

    Object.keys(this.infosFormComponent.infosForm.controls).forEach((key) => {
      const control = this.infosFormComponent.infosForm.controls[key];
      if (!control.valid) {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }
}
